import $ from 'jquery'
let getCookie;

getCookie = name => {
  let cookie;
  let cookieValue;
  let cookies;
  let i;
  cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    cookies = document.cookie.split(";");
    i = 0;
    while (i < cookies.length) {
      cookie = $.trim(cookies[i]);
      if (cookie.substring(0, name.length + 1) === `${name}=`) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
      i++;
    }
  }
  return cookieValue;
};

export default getCookie;
